import './SectionComplexView.css';
export default {
    "wrapper": "SectionComplexView_wrapper__1afub",
    "title": "SectionComplexView_title__1afub",
    "content": "SectionComplexView_content__1afub"
};
